export default "__VITE_ASSET__9542b790__"